import React, { Component } from 'react';
import { ThemeProvider } from 'styled-components';
import BlueprintTheme from 'blueprint/js/BlueprintTheme.js';
import Text from '@bit/knotchinc.web-react-components.text';
import Box from '@bit/knotchinc.web-react-components.box';
import Mixpanel from 'helpers/Mixpanel.js';
import { NoProductsPageContainer } from './styled';

class MaintenancePage extends Component {
  componentDidMount() {
    Mixpanel.track('view Maintenance Page');
  }

  render() {
    return (
      <ThemeProvider theme={BlueprintTheme}>
        <NoProductsPageContainer>
          <Box fontSize="15px">
            <Text fontWeight="thin" fontSize="40px">Maintenance</Text>
            <Box mt="24px" mb="24px" maxWidth="700px">
              We’re currently in maintenance mode, we’ll be back online soon!
            </Box>
          </Box>
        </NoProductsPageContainer>
      </ThemeProvider>
    );
  }
}


export default MaintenancePage;
